import * as cryptoJS from "crypto-js";

class StringUtil {

    static clear(str: string): string {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }

    static truncate(str: string, length: number) {
        const truncated: string = str?.substring(0, length) || "";
        return `${truncated}${str?.length > truncated?.length ? "..." : ""}`;

    }

    static encode(subject: any, cipher?: string): string {
        const key = cipher || `${process.env.REACT_APP_CIPHER}`;
        const str: string = JSON.stringify(subject)
        return cryptoJS.AES.encrypt(str, key).toString()
    }

    static decode<T = any>(hash: string, cipher?: string): T {
        const key = cipher || `${process.env.REACT_APP_CIPHER}`;
        return JSON.parse(cryptoJS.AES.decrypt(hash, key).toString(cryptoJS.enc.Utf8));
    }

    static encode64(codigoVenda: string, sValores: boolean, key: string): string {
        const combined = `${codigoVenda}:${sValores}`;
        return this.encode(combined, key)?.replace(/\+/g, "-")?.replace(/\//g, "_")?.replace(/=+$/, "");
    }

    static decode64(encoded: string, key: string): string {
        return this.decode(this.fromBase64Url(encoded), key);
    }

    static fromBase64Url(base64url: string ): string {
        let base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
        while (base64.length % 4) {
            base64 += "=";
        }
        return base64;
    }
}


export { StringUtil }